export const markdown_faq_34_1 = `INBEE offre una App pensata per ottimizzare la fase di ispezione in campo.

L'app è completamente gratuita, compatibile sia con il sistema IOS che Android, in grado di lavorare offline, consentendo di sincronizzare i dati inseriti con la piattaforma anche una volta tornati in ufficio.

**PER SCARICARE L'APP**
1. Accedere al Play Store o all'App Store dal tuo smartphone
2. Cercare *INBEE*
3. Inserire le credenziali del tuo account INBEE.
Troverai direttamente sull'app i ponti associati al tuo account.`;
